import React from 'react';
import styled from 'styled-components';
import FormRow from './FormRow';
import InputLabel from '../common/InputLabel';
import OutputLabel from '../common/OutputLabel';
import messages from './messages';
import Graphs from './Graphs';
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';

import { FormattedMessage } from 'react-intl';

const Title = styled.h2`
    font-family: ${({ theme }) => theme.font.title};
    font-size: 1.9em;
    color: ${({ theme }) => theme.colour.dark};
    text-align: left;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
`;

const Results = ({ data, showResult }) => {
    const arrow =
        data && data.direction === 'higher' ? (
            <ArrowUpOutlined
                style={{
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    color: '#df2424',
                    fontSize: '20px',
                }}
            />
        ) : (
            <ArrowDownOutlined
                style={{
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    color: '#3aaf44',
                    fontSize: '20px',
                }}
            />
        );

    return (
        <div>
            {showResult && (
                <>
                    <hr style={{ marginBottom: '2em' }} />
                    <Title>
                        <FormattedMessage {...messages.resultsRequired} />
                    </Title>
                    <div className="rateChaImp-results-description">
                        {data.direction === 'higher' ? (
                            <>
                                <h3>
                                    {`Based on your proposed rate change, you will need to sell ${data.actualRooms} additional rooms in order to match the same revenue your existing rate will yield.`}
                                </h3>
                                <h3 style={{ marginTop: '20px' }}>
                                    <FormattedMessage {...messages.dropRateConsider} />
                                </h3>
                            </>
                        ) : (
                            <>
                                <h3>
                                    {`Based on your proposed rate change, you will need to sell ${Math.abs(
                                        data.actualRooms,
                                    )} fewer rooms in order to match the same revenue your existing rate will yield.`}
                                </h3>
                                <h3 style={{ marginTop: '20px' }}>
                                    <FormattedMessage {...messages.raiseRateConsider} />
                                </h3>
                            </>
                        )}
                    </div>
                    <FormRow
                        style={{
                            display: 'inline-flex',
                            alignContent: 'center',
                            fontSize: '1.1em',
                            textAlign: 'center',
                            fontWeight: 'bold',
                        }}
                    >
                        <div className="rateChaImp-result-row-section">
                            <InputLabel
                                text={<FormattedMessage {...messages.newOccupancy} />}
                                style={{ alignItems: 'center', width: '50%' }}
                            />

                            <OutputLabel
                                text={`${data.newOccupancy}%`}
                                className="rateChaImp-form-output"
                                style={{
                                    alignContent: 'center',
                                    textAlign: 'center',
                                    width: '30%',
                                }}
                            />
                            {arrow}
                        </div>
                        <div className="rateChaImp-result-row-section">
                            <InputLabel
                                text={<FormattedMessage {...messages.newRooms} />}
                                style={{ alignItems: 'center', width: '50%' }}
                            />

                            <OutputLabel
                                text={`${data.newRooms} rooms`}
                                className="rateChaImp-form-output"
                                style={{
                                    alignContent: 'center',
                                    textAlign: 'center',
                                    width: '30%',
                                }}
                            />
                            {arrow}
                        </div>
                    </FormRow>
                    <FormRow
                        style={{
                            display: 'inline-flex',
                            alignContent: 'center',
                            fontSize: '1.1em',
                            textAlign: 'center',
                            fontWeight: 'bold',
                        }}
                    >
                        <div className="rateChaImp-result-row-section">
                            <InputLabel
                                text={<FormattedMessage {...messages.additionalOccupancy} />}
                                style={{ alignItems: 'center', width: '50%' }}
                            />

                            <OutputLabel
                                text={`${data.addOccupancy}%`}
                                className="rateChaImp-form-output"
                                style={{
                                    alignContent: 'center',
                                    textAlign: 'center',
                                    width: '30%',
                                }}
                            />
                            {arrow}
                        </div>
                        <div className="rateChaImp-result-row-section">
                            <InputLabel
                                text={<FormattedMessage {...messages.actualRooms} />}
                                style={{ alignItems: 'center', width: '50%' }}
                            />

                            <OutputLabel
                                text={`${data.actualRooms} rooms`}
                                className="rateChaImp-form-output"
                                style={{
                                    alignContent: 'center',
                                    textAlign: 'center',
                                    width: '30%',
                                }}
                            />
                            {arrow}
                        </div>
                    </FormRow>
                    <Graphs formState={data} />
                </>
            )}
        </div>
    );
};

export default Results;
